module.exports = __webpack_public_path__ + "img/box.fa5777b8.png";